import {useState} from "react";

// Л — какво ще стане, ПРЕДИ да стане. Този екран е смисълът на целия внос:
// сгрешен файл се вижда тук, а не в справка С5 след два месеца.

const ACTION_LABEL = {
    insert: {text: "ще се запише", cls: "text-success"},
    skip: {text: "вече съществува", cls: "text-muted"},
    conflict: {text: "различна стойност — прескача се", cls: "text-warning"},
    blocked: {text: "неразпознат ползвател", cls: "text-danger"},
    duplicate_in_file: {text: "повтаря се във файла", cls: "text-warning"},
    zero: {text: "площ 0 — прескача се", cls: "text-muted"},
};

const SHOW_FIRST = 60;

const Badge = ({action}) => {
    const a = ACTION_LABEL[action] || {text: action, cls: "text-muted"};
    return <span className={a.cls} style={{fontSize: "0.8rem"}}>{a.text}</span>;
};

const dka = (n) => (n === null || n === undefined ? "—" : Number(n).toFixed(3));

export const ImportReport = ({report, kind}) => {
    const [showAll, setShowAll] = useState(false);
    if (!report) return null;

    const t = report.totals || {};
    const items = report.items || [];
    const shown = showAll ? items : items.slice(0, SHOW_FIRST);

    return (
        <div className="mt-3">
            {report.fatal && report.fatal.length > 0 && (
                <div className="alert alert-danger">
                    <strong>Файлът не може да се качи:</strong>
                    <ul className="mb-0 mt-2">
                        {report.fatal.map((f, i) => <li key={i}>{f}</li>)}
                    </ul>
                </div>
            )}

            <ul className="list-group">
                <li className="list-group-item list-group-item-secondary">
                    Преглед{report.year ? ` — ${report.year} г.` : ""}
                    {report.settlement_name ? `, ${report.settlement_name} (${report.ekatte})` : ""}
                </li>
                <li className="list-group-item">Редове във файла: {report.rows_total}</li>
                <li className="list-group-item text-success fw-bold">
                    За записване: {t.insert || 0}
                    {" · "}
                    {kind === "deals" ? "общо" : "обща площ"} {dka(t.amount)}
                </li>
                {(t.skip || 0) > 0 && (
                    <li className="list-group-item">Вече съществуват: {t.skip}</li>
                )}
                {(t.conflict || 0) > 0 && (
                    <li className="list-group-item text-warning">
                        С различна стойност (прескачат се): {t.conflict}
                    </li>
                )}
                {(t.blocked || 0) > 0 && (
                    <li className="list-group-item text-danger">
                        Блокирани от неразпознато име: {t.blocked}
                    </li>
                )}
                {(t.zero || 0) > 0 && (
                    <li className="list-group-item">
                        Без площ или с площ 0 (не се качват): {t.zero}
                    </li>
                )}
                {(t.duplicate_in_file || 0) > 0 && (
                    <li className="list-group-item text-warning">
                        Повтарящи се във файла: {t.duplicate_in_file}
                    </li>
                )}
                {(t.will_delete || 0) > 0 && (
                    <li className="list-group-item text-danger fw-bold">
                        ⚠ Заместване: ще бъдат изтрити {t.will_delete}
                        {kind === "deals" ? " съществуващи замени" : " съществуващи записа"}
                    </li>
                )}
                {report.row_errors_total > 0 && (
                    <li className="list-group-item text-danger">
                        Редове с грешка: {report.row_errors_total}
                    </li>
                )}
            </ul>

            {report.warnings && report.warnings.length > 0 && (
                <div className="alert alert-warning mt-2 mb-0">
                    <ul className="mb-0">
                        {report.warnings.map((w, i) => <li key={i}>{w}</li>)}
                    </ul>
                </div>
            )}

            {report.row_errors && report.row_errors.length > 0 && (
                <details className="mt-2">
                    <summary className="text-danger">
                        Грешки по редове ({report.row_errors_total})
                    </summary>
                    <ul className="mt-2" style={{fontSize: "0.85rem"}}>
                        {report.row_errors.map((e, i) => (
                            <li key={i}>ред {e.row}: {e.message}</li>
                        ))}
                    </ul>
                    {report.row_errors_total > report.row_errors.length && (
                        <p className="text-muted" style={{fontSize: "0.85rem"}}>
                            …показани са първите {report.row_errors.length}.
                        </p>
                    )}
                </details>
            )}

            {items.length > 0 && (
                <details className="mt-2" open={items.length <= SHOW_FIRST}>
                    <summary>Ред по ред ({items.length})</summary>
                    <div className="table-responsive mt-2">
                        <table className="table table-sm">
                            <thead>
                            {kind === "deals" ? (
                                <tr>
                                    <th>Даващ</th>
                                    <th>Взимащ</th>
                                    <th>За село</th>
                                    <th className="text-end">Сума (дка)</th>
                                    <th>От редове</th>
                                    <th>Състояние</th>
                                </tr>
                            ) : (
                                <tr>
                                    <th>Ред</th>
                                    <th>Ползвател</th>
                                    <th>Масив</th>
                                    <th>МПО</th>
                                    <th className="text-end">Площ (дка)</th>
                                    <th>Състояние</th>
                                </tr>
                            )}
                            </thead>
                            <tbody>
                            {shown.map((it, i) => kind === "deals" ? (
                                <tr key={i}>
                                    <td>{it.giving_name}</td>
                                    <td>{it.receiving_name}</td>
                                    <td>{it.target_name} ({it.target_ekatte})</td>
                                    <td className="text-end">
                                        {dka(it.amount)}
                                        {it.from_rows.length > 1 && (
                                            <div className="text-muted" style={{fontSize: "0.75rem"}}>
                                                {it.from_rows.length} слети реда
                                            </div>
                                        )}
                                        {it.existing_amount !== undefined && (
                                            <div className="text-muted" style={{fontSize: "0.75rem"}}>
                                                в базата: {dka(it.existing_amount)}
                                            </div>
                                        )}
                                    </td>
                                    <td className="text-muted" style={{fontSize: "0.8rem"}}>
                                        {it.from_rows.join(", ")}
                                    </td>
                                    <td><Badge action={it.action}/></td>
                                </tr>
                            ) : (
                                <tr key={i}>
                                    <td className="text-muted">{it.row}</td>
                                    <td>{it.user_name}</td>
                                    <td>{it.massif}</td>
                                    <td>{it.mpo}</td>
                                    <td className="text-end">
                                        {dka(it.area)}
                                        {it.existing_area !== undefined && (
                                            <div className="text-muted" style={{fontSize: "0.75rem"}}>
                                                в базата: {dka(it.existing_area)}
                                            </div>
                                        )}
                                    </td>
                                    <td><Badge action={it.action}/></td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </div>
                    {items.length > SHOW_FIRST && (
                        <button type="button" className="btn btn-sm btn-outline-secondary"
                                onClick={() => setShowAll(!showAll)}>
                            {showAll ? "Покажи по-малко" : `Покажи всички ${items.length}`}
                        </button>
                    )}
                </details>
            )}
        </div>
    );
};
